import { Api } from '../api/Api.js'

// دریافت اطلاعات لازم برای ثبت سفارش
export function apiGetDataStoreOrder() {
  return Api('get', '/card/get_data_store_order')
}

export function apiStoreNewOrder(body) {
  return Api('post', '/card/store_new_order', { body })
}

export function apiStoreSaleInvoice(body) {
  return Api('post', '/card/store_new_order', { body })
}

export function apiGetOrders(params) {
  return Api('get', '/card/get_cards', { params })
}

export function apiGetOrderDetails(orderId) {
  return Api('get', `/card/get_order_details/${orderId}`)
}

export function apiGetOrderFilterData() {
  return Api('get', '/card/get_order_filter_data')
}

export function apiGetCarInfo(params) {
  return Api('get', '/car/get_car_info', { params })
}

export function apiStoreNumberBar(body) {
  return Api('post', '/card/store_number_bar', { body })
}

export function apiEditOrder(body) {
  return Api('post', '/card/update', { body })
}

export function apiUpdateOrderBaseDetails(body) {
  return Api('post', '/orders/update_base_details', { body })
}

export const apiCancelOrder = (orderId, params) => {
  return Api('get', `/card/disable_card/${orderId}`, { params })
}

export function getPricePerTon(order) {
  let price_per_ton = ''
  if (order.type_arz && order.type_arz !== 'IRR') {
    price_per_ton = round(order.price_per_ton_arz)
  } else {
    price_per_ton = new Intl.NumberFormat('fa-IR').format(order.price_per_ton)
  }

  if (!!!price_per_ton) return 'ثبت نشده'
  return price_per_ton + ' ' + order.type_arz_title
}

export function round(value, decimals = 2) {
  const num = parseFloat(value)
  if (isNaN(num)) return ''
  return Number.isInteger(num) ? num : Number(num.toFixed(decimals))
}
